export default {
	name: "Kana",
	type: "kana",
	logo: "/images/logos/Kana-logo-gradient.jpg",
	subsections: [
		{
			name: "API Connector",
			type: "api connector",
			icon: "compare_arrows",
			activeRules: [
				{
					target: "integration",
					field: "valid",
					value: true
				}
			],
			items: [
				{
					field: "queueId",
					label: "Queue ID",
					type: "text",
					validation: [
						{
							type: "min-length",
							value: 2
						}
					]
				}
			]
		},
		{
			name: "Rules",
			type: "rules",
			icon: "call_split",
			activeRules: [
				{
					target: "integration",
					field: "rules",
					type: "arrayCheck"
				},
				{
					target: "integration",
					field: "rules",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Users for reassigning",
			type: "users",
			icon: "account_box",
			activeRules: [
				{
					target: "component",
					field: "clientAgents",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "clientAgents",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Blacklisted words/expressions",
			type: "blacklist",
			icon: "block",
			activeRules: [
				{
					target: "component",
					field: "blacklist",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "blacklist",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Ticket signature",
			type: "signature",
			icon: "create",
			activeRules: [
				{
					target: "component",
					field: "signature",
					type: "exists"
				}
			]
		}
	],
	refreshableFields: [
		{
			text: "Kana users/groups",
			value: "users"
		},
		{
			text: "Tags",
			value: "tags"
		},
		{
			text: "Macros",
			value: "macros"
		},
		{
			text: "Check filters",
			value: "checkfilters"
		}
	],
	submitOptions: ["open", "solved"],
	ticketOptions: {
		merge: false,
		editTo: false,
		editCC: true,
		editBCC: false
	}
};
